import _useMount from 'react-use/esm/useMount';
import {notify} from '@gemcook/notification';

import utils from '@utils';
import constants from '@constants';

export const useMount = (
  props: any,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const query = utils.queryParams.parse(props.location.search);

  _useMount(async () => {
    try {
      await props.actions.notifications.getDetailAnswer(
        query.id,
        props.notifications.detail.pagination.data.active,
        query.notificationId,
        props.me,
        props.notifications.detail.sentDatetime
      );
    } catch (error) {
      switch (error.response.data.message) {
        case 'notification not found':
        case 'userNotification not found':
          setIsModal(true);
          break;

        default:
          notify(constants.ERRORS.UNKNWON, 'error');
          break;
      }
    }
  });
};
